import { Search } from 'lucide-react';
import { cn } from '~/utils';
import type { ComboboxInputProps } from '~/hooks/useCombobox';

const DEFAULT_WIDTH_CLASSES = 'min-w-[180px] max-w-xs';

type SearchInputProps = {
  readonly value: string;
  readonly onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  readonly placeholder: string;
  readonly ariaLabel: string;
  readonly testId?: string;
  readonly widthClassName?: string;
  readonly inputRef?: React.Ref<HTMLInputElement>;
  readonly onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  readonly comboboxProps?: ComboboxInputProps;
};

export function SearchInput({
  value,
  onChange,
  placeholder,
  ariaLabel,
  testId,
  widthClassName,
  inputRef,
  onKeyDown,
  comboboxProps,
}: SearchInputProps) {
  return (
    <div
      className={cn('relative flex-1', widthClassName ?? DEFAULT_WIDTH_CLASSES)}
    >
      <Search
        size={16}
        className="absolute left-3 top-1/2 -translate-y-1/2 text-neut-400 pointer-events-none"
      />
      <input
        type="text"
        placeholder={placeholder}
        aria-label={ariaLabel}
        value={value}
        onChange={onChange}
        data-testid={testId}
        ref={inputRef}
        onKeyDown={onKeyDown}
        {...comboboxProps}
        className="w-full pl-9 pr-3 py-2 text-sm border border-neut-border rounded-md bg-neut-bg focus:outline-none focus:ring-2 focus:ring-prim focus:border-transparent placeholder:text-neut-400"
      />
    </div>
  );
}
